import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import columnInfoGroupSectionCell from './columnInfoGroupSectionCell.js';
import arrayEntry from '../fragments/arrayEntry.js';
var schema = defineObject('columnInfoGroupSection', {
    title: {
        title: 'Title',
        type: 'string'
    },
    cells: {
        title: 'Cells',
        type: 'array',
        of: [
            {
                type: 'columnInfoGroupSectionCell'
            }
        ]
    }
}, [
    columnInfoGroupSectionCell.schema.columnInfoGroupSectionCell
]);
var validator = z.object({
    _type: z.literal('columnInfoGroupSection'),
    title: z.string().optional(),
    cells: z.array(columnInfoGroupSectionCell.validator.merge(arrayEntry.validator)).optional()
});
schema.columnInfoGroupSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=columnInfoGroupSection.js.map